module.exports = __webpack_public_path__ + "static/media/npmmSearchResult.e9857f44.PNG";